import styled from 'styled-components'
import button from './button'

const ToggleButton = styled.button`
  ${button.defaultStyles}
`

export default ToggleButton
